import { createSlice } from '@reduxjs/toolkit';
import {
  fetchAccessoryByType,
  fetchInsideAccessories,
} from '../actions/insideAccessory.action';
import { roomPriceContextChanged } from '../actions/roomPriceContext.action';

const initialState = {
  insideAccessories: {
    data: {},
    isLoading: false,
    isNeedReloadData: true,
  },
  accessoriesByType: {
    data: [],
    isLoading: false,
    isNeedReloadData: true,
  },
};

export const insideAccessoryReducer = createSlice({
  name: 'InsideAccessory',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(roomPriceContextChanged, () => initialState)
      .addCase(fetchInsideAccessories.pending, state => {
        state.insideAccessories = {
          ...state.insideAccessories,
          data: {},
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchInsideAccessories.fulfilled, (state, action) => {
        if (action.payload?.data) {
          const data = action.payload?.data;
          state.insideAccessories = {
            ...state.insideAccessories,
            data,
            isLoading: false,
          };
        }
      })
      .addCase(fetchInsideAccessories.rejected, state => {
        state.insideAccessories = {
          ...state.insideAccessories,
          data: {},
          isLoading: false,
        };
      })
      .addCase(fetchAccessoryByType.pending, state => {
        state.accessoriesByType = {
          ...state.accessoriesByType,
          data: [],
          isLoading: true,
          isNeedReloadData: false,
        };
      })
      .addCase(fetchAccessoryByType.fulfilled, (state, action) => {
        if (action.payload?.data) {
          const data = action.payload?.data;
          state.accessoriesByType = {
            ...state.accessoriesByType,
            data,
            isLoading: false,
          };
        }
      })
      .addCase(fetchAccessoryByType.rejected, state => {
        state.accessoriesByType = {
          ...state.accessoriesByType,
          data: [],
          isLoading: false,
        };
      });
  },
});

export default insideAccessoryReducer.reducer;
